import { motion } from "framer-motion"
import type { Variants } from "framer-motion"
import CrisisSection from "./sections/CrisisSection"
import HeroSection from "./sections/HeroSection"
import CostSection from "./sections/CostSection"
import SolutionSection from "./sections/SolutionSection"
import SecuritySection from "./sections/SecuritySection"
import AwardsSection from "./sections/AwardsSection"
import TeamSection from "./sections/TeamSection"
import TestimonialSection from "./sections/TestimonialSection"
import FooterSection from "./sections/FooterSection"
import "./sections/index.scss"

// Animation variants for sections
const sectionVariants: Variants = {
  hidden: {
    opacity: 0,
    y: 50,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.46, 0.45, 0.94] as [number, number, number, number],
    },
  },
}

const LandingPage = () => {
  return (
    <>
      <HeroSection />
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={sectionVariants}
      >
        <CrisisSection />
      </motion.div>
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={sectionVariants}
      >
        <CostSection />
      </motion.div>
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={sectionVariants}
      >
        <SolutionSection />
      </motion.div>
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={sectionVariants}
      >
        <SecuritySection />
      </motion.div>
      <motion.div
        // initial=
        whileInView="visible"
        viewport={{ once: true, margin: "0px" }}
        variants={sectionVariants}
      >
        <AwardsSection />
      </motion.div>
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={sectionVariants}
      >
        <TeamSection />
      </motion.div>
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={sectionVariants}
      >
        <TestimonialSection />
      </motion.div>
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={sectionVariants}
      >
        <FooterSection />
      </motion.div>
    </>
  )
}

export default LandingPage
 